import { render, staticRenderFns } from "./keyword-query-form.vue?vue&type=template&id=0fb3219c&scoped=true"
import script from "./keyword-query-form.vue?vue&type=script&setup=true&lang=js"
export * from "./keyword-query-form.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb3219c",
  null
  
)

export default component.exports